// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Tiktok from '../_raw/ui/icon_tiktok.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Tiktok);
